import React from 'react';
import { TooltipInfoIcon } from 'common/tooltip-info-icon';
import { DescriptionColumn } from './description-column';
import { Row } from './row';
import { ProviderColumn } from './provider-column';

export const TaxableReceiptsPrimaryRow = ({ primaryItem, providers }) => (
  <Row paddingBottom={'8px'}>
    <DescriptionColumn fontSize={16} padding={'5px 0px 10px 15px'}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {primaryItem.label}
        {primaryItem.infoText && <TooltipInfoIcon placement={'right'} text={primaryItem.infoText} iconSize={'16px'} iconMargin={'0px 0px 0px 5px'} />}
      </div>
    </DescriptionColumn>
    {providers.map((provider) => {
      const value = primaryItem.providerValues.find((values) => values.providerID === provider.id)?.value || '';
      return (
        <ProviderColumn key={`taxbleReceiptsPrimaryItem_${provider.id}`} style={{ paddingLeft: 500 }}>
          {value}
        </ProviderColumn>
      );
    })}
  </Row>
);
